import { TDeviceType } from '@cian/ui-kit';
import { TTabsTheme } from '../../types';

interface IStyles {
  'wrap-left-blur'?: string;
  'wrap-right-blur'?: string;
}

export const getTheme = (deviceType: TDeviceType, theme: TTabsTheme) => {
  if (deviceType === 'phone') {
    return {};
  }

  return require(`./themes/${theme}.css`) as IStyles;
};
